<template>
  <div>
    <div class="photoContainer">
      <img src="frontImages/ibc86.jpg" class="topPhoto" />
    </div>

    <div class="separator"></div>

    <h1>{{ $t("servicedOfficesPage.h1") }}</h1>

    <p class="text">{{ $t("servicedOfficesPage.p1") }}</p>

    <p class="text">{{ $t("servicedOfficesPage.p2") }}</p>

    <p class="text">{{ $t("servicedOfficesPage.p3") }}</p>

    <vue-picture-swipe :items="items"></vue-picture-swipe>

    <br>

    <vue-picture-swipe :items="items1"></vue-picture-swipe>

    <div class="separator"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // TODO: change images
      items: [
        {
          src: "images/serviced_office/ibc_serviced_office_01.jpg",
          thumbnail: "images/serviced_office/thumb_01.jpg",
          w: 1920,
          h: 1281
        },
        {
          src: "images/serviced_office/ibc_serviced_office_02.jpg",
          thumbnail: "images/serviced_office/thumb_02.jpg",
          w: 1920,
          h: 1281
        },
        {
          src: "images/serviced_office/ibc_serviced_office_03.jpg",
          thumbnail: "images/serviced_office/thumb_03.jpg",
          w: 1920,
          h: 1281
        },
        {
          src: "images/serviced_office/ibc_serviced_office_04.jpg",
          thumbnail: "images/serviced_office/thumb_04.jpg",
          w: 1920,
          h: 2877
        }
      ],
      items1: [
        {
          src: "images/serviced_office/ibc_serviced_office_05.jpg",
          thumbnail: "images/serviced_office/thumb_05.jpg",
          w: 1920,
          h: 2877
        },
        {
          src: "images/serviced_office/ibc_serviced_office_06.jpg",
          thumbnail: "images/serviced_office/thumb_06.jpg",
          w: 1920,
          h: 1282
        },
        {
          src: "images/serviced_office/ibc_serviced_office_07.jpg",
          thumbnail: "images/serviced_office/thumb_07.jpg",
          w: 1920,
          h: 1281
        },
        // {
        //   src: "images/serviced_office/ibc_serviced_office_08.jpg",
        //   thumbnail: "images/serviced_office/thumb_08.jpg",
        //   w: 1920,
        //   h: 1281
        // },
        {
          src: "images/serviced_office/ibc_serviced_office_09.jpg",
          thumbnail: "images/serviced_office/thumb_09.jpg",
          w: 1920,
          h: 1281
        }
      ]
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
</script>

<style scoped>
h1 {
  font-family: "Lato", sans-serif;
  font-weight: 500;
}

.text {
  font-family: "Lato", sans-serif;
  color: #646464;
  text-align: left;
  padding: 1rem;
}
</style>
